document.addEventListener('click', function(event) {
  const tab = event.target.closest('[data-product-tabs] .product-details-tab');
  if (!tab) return;
  const container = tab.closest('[data-product-tabs]');
  const targetId = tab.getAttribute('data-detail-target');
  if (!container || !targetId) return;
  container.querySelectorAll('.product-details-tab').forEach(function(button) {
    button.setAttribute('aria-selected', button === tab ? 'true' : 'false');
  });
  container.querySelectorAll('.product-details-pane').forEach(function(panel) {
    panel.hidden = panel.id !== targetId;
  });
});

document.addEventListener('keydown', function(event) {
  const tab = event.target.closest('[data-product-tabs] .product-details-tab');
  if (!tab || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
  const tabs = Array.from(tab.closest('[role="tablist"]').querySelectorAll('.product-details-tab'));
  const current = tabs.indexOf(tab);
  const direction = event.key === 'ArrowRight' ? 1 : -1;
  const next = tabs[(current + direction + tabs.length) % tabs.length];
  event.preventDefault();
  next.focus();
  next.click();
});

const fallingLeafPunPools = {
  1: [
    { heading: 'Steep dreams', text: 'Tea worth slowing down and staying awhile for.' },
    { heading: 'You’re my cup of tea', text: 'Find a blend that suits you to a tea.' },
    { heading: 'Sip happens', text: 'When the day gets steep, put the kettle on.' },
    { heading: 'Brew can do it', text: 'A good cup can turn an ordinary moment into something worth savoring.' },
    { heading: 'Steep calm and carry on', text: 'Take five, pour a cup, and let the rest wait a minute.' },
    { heading: 'Infuse your day', text: 'Pick a blend, add hot water, and make a little room for yourself.' }
  ],
  2: [
    { heading: 'What’s the deal?', text: 'Tarot and oracle decks for when you’d like the cards to have a word.' },
    { heading: 'Deal me in', text: 'Put your questions on the table and see what turns up.' },
    { heading: 'It’s in the cards', text: 'For reflection, curiosity, and the occasional beautifully timed nudge.' },
    { heading: 'Tarot-ble at decisions?', text: 'Sometimes a fresh perspective is exactly what the cards ordered.' },
    { heading: 'Pick a card, any card', text: 'Explore decks that invite you to look closer, wonder more, and trust your own read.' },
    { heading: 'Major arcana energy', text: 'For days that call for a little symbolism, story, and soul-searching.' }
  ],
  3: [
    { heading: 'No present like the present', text: 'Tea, tarot, and curious little treasures worth wrapping up.' },
    { heading: 'Gift happens', text: 'Good thing you found something thoughtful before showing up empty-handed.' },
    { heading: 'Present tense', text: 'Find something thoughtful for the tea lover, tarot reader, or curious soul in your life.' },
    { heading: 'Present company included', text: 'Thoughtful finds for tea lovers, curious souls, and your favorite hard-to-shop-for human.' },
    { heading: 'A gift with steep meaning', text: 'Give them something they can sip, shuffle, savor, or keep.' },
    { heading: 'You shouldn’t have… but do', text: 'Little luxuries and meaningful finds are much more fun when shared.' }
  ],
  4: [
    { heading: 'Curiosi-tea encouraged', text: 'Wander freely. You never know what might be your cup of tea.' },
    { heading: 'Stay brew-sy', text: 'Poke around. The thing you didn’t know you wanted may be one click away.' },
    { heading: 'Leaf your options open', text: 'Explore a little farther than planned and see what catches your eye.' },
    { heading: 'Follow your curiosi-tea', text: 'The best finds often start with “I wonder what this is…”' },
    { heading: 'Wander this way', text: 'Take the scenic route through tea, tarot, and whatever else calls your name.' },
    { heading: 'Brewse around', text: 'No agenda required. Sometimes browsing is part of the ritual.' }
  ]
};

function chooseDifferentPun(slot, pool) {
  const storageKey = 'falling-leaf-pun-slot-' + slot;
  let previous = -1;
  try {
    previous = Number.parseInt(window.localStorage.getItem(storageKey), 10);
  } catch (error) {
    previous = -1;
  }

  const choices = pool.map(function(_, index) { return index; }).filter(function(index) {
    return index !== previous;
  });
  const selected = choices[Math.floor(Math.random() * choices.length)];

  try {
    window.localStorage.setItem(storageKey, String(selected));
  } catch (error) {
    // Rotation still works when storage is unavailable; only repeat prevention is skipped.
  }

  return pool[selected];
}

function initializePunnyHighlights(root) {
  const scope = root || document;
  scope.querySelectorAll('[data-punny-highlights]').forEach(function(section) {
    section.querySelectorAll('[data-punny-slot]').forEach(function(item) {
      const slot = item.getAttribute('data-punny-slot');
      const pool = fallingLeafPunPools[slot];
      if (!pool || pool.length < 2) return;

      const selected = chooseDifferentPun(slot, pool);
      const heading = item.querySelector('[data-punny-heading]');
      const text = item.querySelector('[data-punny-text]');
      if (heading) heading.textContent = selected.heading;
      if (text) text.textContent = selected.text;
    });
  });
}

initializePunnyHighlights(document);

document.addEventListener('shopify:section:load', function(event) {
  initializePunnyHighlights(event.target);
});